export function mulberry32Step(state: number): {
  value: number;
  nextState: number;
} {
  let t = (state + 0x6d2b79f5) >>> 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return { value: ((t ^ (t >>> 14)) >>> 0) / 4294967296, nextState: t };
}

export function shuffleBag<T>(
  bag: readonly T[],
  rngState: number,
): { shuffled: readonly T[]; nextState: number } {
  const arr = [...bag];
  let state = rngState;
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const { value, nextState } = mulberry32Step(state);
    state = nextState;
    const j = Math.floor(value * (i + 1));
    const tmp = arr[i];
    arr[i] = arr[j] as T;
    arr[j] = tmp as T;
  }
  return { shuffled: arr, nextState: state };
}

export function fnv1aHash(str: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) {
    hash ^= str.charCodeAt(i);
    hash = (hash * 0x01000193) >>> 0;
  }
  return hash;
}
